import React, { useContext, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Box } from "@rebass/grid";
import { LoginWrapper } from "../login/styled/SLogin";
import { Header, Button, Input } from "../../components";
import { ProfileContext } from "../../providers/ProfileProvider";
import { Redirect } from "react-router";
import { AuthenticationContext } from "../../providers/AuthenticationProvider";
import { useTranslation } from "react-i18next";

interface FormValues {
  password: string;
  repeatPassword: string;
}

const NewPassword = () => {
  const { setNewPassword } = useContext(ProfileContext);
  const { logOut } = useContext(AuthenticationContext);
  const [passwordResetDone, setPasswordResetDone] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const { t } = useTranslation();

  const PasswordResetSchema = Yup.object().shape({
    password: Yup.string()
      .min(2, t("VALIDATION_MIN_LENGTH_PLACEHOLDER", { placeholder: 2 }))
      .max(50, t("VALIDATION_MAX_LENGTH_PLACEHOLDER", { placeholder: 50 }))
      .required(t("VALIDATION_REQUIRED")),
    repeatPassword: Yup.string()
      .required(t("VALIDATION_REQUIRED"))
      .oneOf([Yup.ref("password"), null], t("VALIDATION_PASSWORD_MATCH")),
  });

  useEffect(() => {
    logOut();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const refreshToken = params.get("refresh");
    const expiresAt = params.get("expires_at");
    if (refreshToken && expiresAt) {
      window.localStorage.setItem("refresh_token", refreshToken);
      window.localStorage.setItem("expires_at", expiresAt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (passwordResetDone) {
    return <Redirect to="/documents" />;
  }
  return (
    <React.Fragment>
      <Formik
        validationSchema={PasswordResetSchema}
        initialValues={{
          password: "",
          repeatPassword: "",
        }}
        onSubmit={(values: FormValues) => {
          setNewPassword(values.password).then(() => {
            setRedirecting(true);
            setTimeout(() => {
              setRedirecting(false);
              setPasswordResetDone(true);
            }, 3000);
          });
        }}
        render={({ touched, errors }) => (
          <Box id="box-password-new" data-page-id="password-new">
            <LoginWrapper>
              {redirecting && <p>{t("RESET_PASSWORD_DONE_REDIRECT_TEXT")}</p>}
              <Header>{t("RESET_PASSWORD_TITLE")}</Header>
              <Form method="post">
                <Box mt={30}>
                  <Input
                    required={true}
                    id="input-password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    icon="user_lock"
                    touched={touched.password}
                    error={errors.password}
                  />
                </Box>
                <Box mt={30}>
                  <Input
                    required={true}
                    id="input-repeat-password"
                    name="repeatPassword"
                    type="password"
                    placeholder="Repeat password"
                    icon="user_lock"
                    touched={touched.repeatPassword}
                    error={errors.repeatPassword}
                  />
                </Box>
                <Box my={30}>
                  <Button
                    id="button-save"
                    fullWidth={true}
                    kind="primary"
                    type="submit"
                    loading={redirecting}
                  >
                    {t("SAVE")}
                  </Button>
                </Box>
              </Form>
            </LoginWrapper>
          </Box>
        )}
      />
    </React.Fragment>
  );
};

export default NewPassword;
